var _circle, _rect, _path, _rect2, _rect3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlarmScheduleClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#70747D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.8335,
    y: 11.75,
    width: 18.3333,
    height: 16.5,
    rx: 1.83333,
    stroke: "white",
    strokeWidth: 1.83333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 14.5H29.1667V27.3333H10.8333V14.5Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5002,
    y: 9,
    width: 1.83333,
    height: 4.58333,
    rx: 0.916667,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.6668,
    y: 9,
    width: 1.83333,
    height: 4.58333,
    rx: 0.916667,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5093 19.048C18.9411 18.8256 19.4309 18.7 19.95 18.7C21.6897 18.7 23.1 20.1103 23.1 21.85C23.1 22.3691 22.9745 22.859 22.752 23.2907L18.5093 19.048ZM17.2628 20.2056C16.9693 20.6843 16.8 21.2474 16.8 21.85C16.8 23.5897 18.2103 25 19.95 25C20.5527 25 21.1158 24.8308 21.5944 24.5373L17.2628 20.2056ZM19.95 17C17.2715 17 15.1 19.1714 15.1 21.85C15.1 24.5286 17.2715 26.7 19.95 26.7C22.6286 26.7 24.8 24.5286 24.8 21.85C24.8 19.1714 22.6286 17 19.95 17Z",
    fill: "#70747D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmScheduleClose);
export default __webpack_public_path__ + "static/media/icon_alarm_schedule_close.e29422bb3f5be978dd7ef723d4695ca4.svg";
export { ForwardRef as ReactComponent };